import { render } from "./WaterBillOnlinePay.vue?vue&type=template&id=05271a3a&scoped=true"
import script from "./WaterBillOnlinePay.vue?vue&type=script&lang=js"
export * from "./WaterBillOnlinePay.vue?vue&type=script&lang=js"

import "./WaterBillOnlinePay.vue?vue&type=style&index=0&id=05271a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05271a3a"]])

export default __exports__